export default __webpack_public_path__ + "static/media/shadow-dark-winter.d0db7e23.png";